export enum ColorsEnum {
    white = 'is-white',
    black = 'is-black',
    primary = 'is-primary',
    link = 'is-link',
    info = 'is-info',
    success = 'is-success',
    warning = 'is-warning',
    dark = 'is-dark',
    light = 'is-light',
    danger = 'is-danger',
}

export type Colors = ColorsEnum.white | ColorsEnum.black | ColorsEnum.primary | ColorsEnum.link |
    ColorsEnum.info | ColorsEnum.success | ColorsEnum.warning | ColorsEnum.dark | ColorsEnum.light | ColorsEnum.danger;
